import React, { useCallback } from 'react'

import { useRouter } from 'next/navigation'

import {
  AppearingWrapper,
  LatestNewsGallery,
  SectionContainer,
} from 'Components/Blocks'
import { SubsectionTitle } from 'Components/Blocks/Titles'
import { Button } from 'Components/UI'

import { LANDING_CONTENT_PX } from 'Constants/Landing'
import { CLUBHOUSE } from 'Constants/Paths'

import { Container } from './styles'

function RelatedBlogsSection() {
  const router = useRouter()

  const handleButtonClick = useCallback(() => {
    router.push(CLUBHOUSE)
  }, [router])

  return (
    <SectionContainer>
      <AppearingWrapper centered>
        <Container
          gap={[10, 10, 10, 13]}
          px={LANDING_CONTENT_PX}
          py={[80, 80, 100]}
        >
          <SubsectionTitle centered title="Related Blogs" />

          <LatestNewsGallery />

          <Button large onClick={handleButtonClick}>
            Explore Our Blogs
          </Button>
        </Container>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default RelatedBlogsSection
